module.exports = __webpack_public_path__ + "static/media/lock.6211df90.svg";